import { environment } from './environment';

const identifier = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
};

const reference = (value = '') => {
  let result = 2166136261;
  for (const character of String(value).slice(0, 4096)) {
    result = Math.imul(result ^ character.charCodeAt(0), 16777619);
  }
  return (result >>> 0).toString(36);
};

const dateValue = (value) => {
  if (value instanceof Date) {
    return Number.isFinite(+value)
      ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(
          2,
          '0',
        )}`
      : '';
  }
  if (typeof value !== 'string') return '';
  const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  const date = match ? `${match[3]}-${match[2]}-${match[1]}` : value.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) &&
    Number.isFinite(Date.parse(date)) &&
    new Date(date).toISOString().slice(0, 10) === date
    ? date
    : '';
};

const selection = ({ dataSource = {}, finder = {}, hotel = {}, urlParams = {} } = {}) => {
  const start = dateValue(dataSource.checkIn || finder.calendar?.[0] || urlParams.checkin);
  const nights = Math.min(366, Math.max(0, Number(dataSource.nights || urlParams.nights) || 0));
  const end =
    dateValue(dataSource.checkOut || finder.calendar?.[1]) ||
    (start && nights ? new Date(Date.parse(start) + nights * 86400000).toISOString().slice(0, 10) : '');
  return {
    hotel: String(hotel?.id || urlParams.idHotel || urlParams.idtokenprovider || '').slice(0, 80),
    start,
    end,
    rooms: Math.min(100, Math.max(1, dataSource.details?.length || finder.occupation?.length || 1)),
    target: reference(`${start}|${end}|${urlParams.rooms || ''}`),
  };
};

const overlaps = (first, second) =>
  !!first.start && !!second.start && first.start < second.end && second.start < first.end;

const contextKey = (context = {}) =>
  JSON.stringify({
    ...selection(context),
    method: context.payment?.method,
    currency: context.currency || context.dataSource?.currency,
    total: context.dataSource?.price?.total,
    selection: Object.fromEntries(
      [
        'rooms',
        'extras',
        'offersAppliedBySelectedRoom',
        'roomNumberBySelectedRoom',
        'totalPrice',
        'applyClubDiscount',
        'checkin',
        'nights',
        'parties',
        'idtokenprovider',
        'idHotel',
        'currency',
      ].map((key) => [key, context.urlParams?.[key]]),
    ),
    form: Object.entries(context.checkout || {}).sort(([first], [second]) => first.localeCompare(second)),
  });

const scopeKey = ({ id, hotel = {}, urlParams = {} } = {}) =>
  `${String(id || urlParams.miraiId || 'default').slice(0, 80)}:${String(
    hotel?.id || urlParams.idHotel || urlParams.idtokenprovider || id || 'default',
  ).slice(0, 80)}`;

export { contextKey, dateValue, environment, identifier, overlaps, reference, scopeKey, selection };
